export const docusignRoles: Record<
  DocusignRoleKey,
  {
    roleName: string;
    recipientId: string;
    description: string;
    required?: boolean;
  }
> = {
  applicationPreparer: {
    roleName: 'Application Preparer',
    recipientId: '1',
    description: 'The person who prepares the application for the client.',
    required: true,
  },
  advisor: {
    roleName: 'Advisor',
    recipientId: '2',
    description: 'The advisor working with the client.',
    required: true,
  },
  primaryInsured: {
    roleName: 'Primary Insured',
    recipientId: '3',
    description: 'The primary insured for the policy.',
    required: true,
  },
  secondaryInsured: {
    roleName: 'Secondary Insured',
    recipientId: '4',
    description: 'The secondary insured for the policy.',
  },
  policyOwner: {
    roleName: 'Policy Owner',
    recipientId: '5',
    description: 'The policy owner.',
    required: true,
  },
  jointOwner: {
    roleName: 'Joint Policy Owner',
    recipientId: '6',
    description: 'The joint policy owner.',
  },
  policyOwnerSpouse: {
    roleName: 'Policy Owner Spouse',
    recipientId: '7',
    description: 'The spouse of the policy owner.',
  },
  irrevocableBeneficiary: {
    roleName: 'Irrevocable Beneficiary',
    recipientId: '8',
    description: 'Beneficiary whose designation cannot be changed without their written consent.',
  },
  agent2: {
    roleName: 'Agent 2',
    recipientId: '9',
    description: 'Second agent.',
  },
  agent3: {
    roleName: 'Agent 3',
    recipientId: '10',
    description: 'Third agent.',
  },
  residentAgent: {
    roleName: 'Resident Agent',
    recipientId: '11',
    description: 'Resident agent for California applications.',
  },
  primaryInsuredSpouse: {
    roleName: 'Primary Insured Spouse',
    recipientId: '12',
    description: 'Primary Insured Spouse for California applications.',
  },
  legalRepresentative: {
    roleName: 'Legal Representative',
    recipientId: '13',
    description: 'Legal Representative for California applications.',
  },
  collateralAssignee: {
    roleName: 'Collateral Assignee',
    recipientId: '14',
    description: 'Collateral assignee for the policy.',
  },
  fieldPrincipal: {
    roleName: 'Field Principal',
    recipientId: '15',
    description: 'Field principal signature for Securian applications.',
  },
  homeOffice: {
    roleName: 'Home Office',
    recipientId: '16',
    description: 'Home office representative signature for Securian applications.',
  },
};
